import React, { useEffect, useState } from "react";
import { useBotbRAFContext } from "../context";
import CopyLinkIcon from "../../../shared-components/icons/CopyLinkIcon";
import { toast } from "react-toastify";
import ToastNotification from "@/app/components/ToastNotification/toastNotification";

const StickyCTADesktop = () => {
  const { rafStatus, loading } = useBotbRAFContext();

  const [shouldShow, setShouldShow] = useState<boolean>(false);
  useEffect(() => {
    const onToggleStickyDesktop = (event: CustomEventInit<boolean>) => {
      setShouldShow(event.detail || false);
    };
    window.addEventListener("toggleStickyDesktop", onToggleStickyDesktop);

    return () => {
      window.removeEventListener("toggleStickyDesktop", onToggleStickyDesktop);
    };
  }, []);

  return (
    <div
      className={`font-jost max-lg:hidden fixed bottom-0 !top-auto inset-x-0 z-[1004] bg-white shadow-[0_1.5px_20px_0_rgba(0,0,0,0.20)] border-t border-black/8 py-3 ${!shouldShow ? "block" : "hidden"}`}>
      <div className={"mainSection mx-auto px-[1.5rem]"}>
        <div className={"flex justify-end"}>
          <div className={"lg:w-full"}>
            <div className={"flex items-center gap-7"}>
              <div className={"flex flex-col justify-center items-start gap-1 shrink-0"}>
                <div className={"text-dark-1 font-jost text-lg font-semibold leading-6 whitespace-nowrap"}>
                  Your invite could be their big break
                </div>
                <div className={"text-gray-1 text-base font-normal leading-[22px] whitespace-nowrap"}>
                  Invite your friends to activate BOTB Pass using your special link:
                </div>
              </div>
              <div className={"flex gap-3.5 grow"}>
                <div
                  className={
                    "w-full h-14 px-5 flex items-center rounded bg-gray-4 border border-black/8 overflow-hidden"
                  }>
                  <span className={" text-dark-1 text-base font-normal leading-5.5 whitespace-nowrap"}>
                    {!loading && rafStatus.referralUrl}
                  </span>
                </div>
                <button
                  onClick={() => {
                    toast.info(<ToastNotification message={"Copy to clipboard was successful!"} useInfoIcon={true} />);
                    navigator.clipboard.writeText(`${rafStatus.referralUrl}`);
                  }}
                  className={"theme-btn theme-btn-primary theme-btn-xl uppercase min-w-[180px]"}>
                  <CopyLinkIcon className={"size-5 shrink-0"} />
                  COPY LINK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyCTADesktop;
